/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesBatchStatus } from './WebApiModelsEnumerationTypesBatchStatus';
import {
    WebApiModelsEnumerationTypesBatchStatusFromJSON,
    WebApiModelsEnumerationTypesBatchStatusFromJSONTyped,
    WebApiModelsEnumerationTypesBatchStatusToJSON,
} from './WebApiModelsEnumerationTypesBatchStatus';

/**
 * DTO for updating a batch job
 * @export
 * @interface WebApiBatchJobDtoUpdateBatchJobDto
 */
export interface WebApiBatchJobDtoUpdateBatchJobDto {
    /**
     * Gets or sets the identifier.
     * @type {number}
     * @memberof WebApiBatchJobDtoUpdateBatchJobDto
     */
    id?: number;
    /**
     * Gets or sets the started at timestamp.
     * @type {Date}
     * @memberof WebApiBatchJobDtoUpdateBatchJobDto
     */
    startedAt?: Date | null;
    /**
     * Gets or sets the completed at timestamp.
     * @type {Date}
     * @memberof WebApiBatchJobDtoUpdateBatchJobDto
     */
    completedAt?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesBatchStatus}
     * @memberof WebApiBatchJobDtoUpdateBatchJobDto
     */
    status?: WebApiModelsEnumerationTypesBatchStatus;
    /**
     * Gets or sets the error message.
     * @type {string}
     * @memberof WebApiBatchJobDtoUpdateBatchJobDto
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the WebApiBatchJobDtoUpdateBatchJobDto interface.
 */
export function instanceOfWebApiBatchJobDtoUpdateBatchJobDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiBatchJobDtoUpdateBatchJobDtoFromJSON(json: any): WebApiBatchJobDtoUpdateBatchJobDto {
    return WebApiBatchJobDtoUpdateBatchJobDtoFromJSONTyped(json, false);
}

export function WebApiBatchJobDtoUpdateBatchJobDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiBatchJobDtoUpdateBatchJobDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'startedAt': !exists(json, 'startedAt') ? undefined : (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': !exists(json, 'completedAt') ? undefined : (json['completedAt'] === null ? null : new Date(json['completedAt'])),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesBatchStatusFromJSON(json['status']),
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function WebApiBatchJobDtoUpdateBatchJobDtoToJSON(value?: WebApiBatchJobDtoUpdateBatchJobDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'startedAt': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': value.completedAt === undefined ? undefined : (value.completedAt === null ? null : value.completedAt.toISOString()),
        'status': WebApiModelsEnumerationTypesBatchStatusToJSON(value.status),
        'errorMessage': value.errorMessage,
    };
}

